// extracted by mini-css-extract-plugin
export default {"room__length":"ArrowsVisualization_room__length__ewKCG","room__width":"ArrowsVisualization_room__width__EUxZs"};